import { Component, OnInit } from '@angular/core';
import { Scene } from 'src/app/models/Scene';
import { ModalController, AlertController } from '@ionic/angular';
import { UnfocusElementService } from 'src/app/services/unfocus-element.service';
import { AddOutcomeActionModalPage } from '../add-outcome-action-modal/add-outcome-action-modal.page';
import { ProjectOutcomeRelationService } from 'src/app/services/project-outcome-relation.service';
import { OutcomesService } from 'src/app/services/outcomes.service';
import { Outcome } from 'src/app/models/outcomes/Outcome';
import { OutcomeAction } from 'src/app/models/outcomes/OutcomeAction';
import { OutcomeActionType } from 'src/app/models/outcomes/OutcomeActionType';
import { OutcomeActionTypeService } from 'src/app/services/outcome-action-type.service';
import { AssetInScene } from 'src/app/models/AssetInScene';
import { OutcomeActionService } from 'src/app/services/outcome-action.service';
import { DeepCopyService } from 'src/app/services/deep-copy.service';
import { ViewOutcomeModalPage } from 'src/app/modals/view-outcome-modal/view-outcome-modal.page';
import { AssetTypeService } from 'src/app/services/asset-type.service';
import { AuthorService } from 'src/app/services/author.service';
import { HelpModalPage } from 'src/app/modals/help-modal/help-modal.page';
import { MessagesService } from 'src/app/services/messages.service';

@Component({
  selector: 'app-outcome-action-management-modal',
  templateUrl: './outcome-action-management-modal.page.html',
  styleUrls: ['./outcome-action-management-modal.page.scss'],
})
export class OutcomeActionManagementModalPage implements OnInit {
  public asset: AssetInScene;
  public scene: Scene;
  public projectId: number;
  public projectOutcomes: Outcome[];
  public outcomeActions: OutcomeAction[];
  public paginateConfig: any;
  public outcomeActionTypes: OutcomeActionType[];
  public projectOutcomeGroups: Outcome[] = [];
  public isModalOpen: boolean = false;

  constructor(
    public modalController: ModalController,
    public unfocusService: UnfocusElementService,
    public ProjectOutcomeRelationService: ProjectOutcomeRelationService,
    public outcomeService: OutcomesService,
    public outcomeActionTypeService: OutcomeActionTypeService,
    public outcomeActionService: OutcomeActionService,
    public deepCopyService: DeepCopyService,
    public alertController: AlertController,
    public assetTypeService: AssetTypeService,
    public authorService: AuthorService,
    public messageService: MessagesService

  ) {
    this.paginateConfig = {
      id: 'first',
      itemsPerPage: 3,
      currentPage: 1
    };
  }

  ngOnInit() {
    this.getProjectOutcomes();
  }

  cancelModal() {
    this.modalController.dismiss();
  }

  getOutcomeTitle(outcomeId) {
    if (this.outcomeService.allOutcomes.length != 0) {
      var outcome = this.outcomeService.allOutcomes.filter(x => x.outcomeId == outcomeId);
      if (outcome.length != 0) {
        return outcome[0].title;
      }
      else {
        return "Outcome Title Not Found";
      }
    }
    else {
      return "Outcome Title Not Found";
    }

  }

  getActionTitle(actionId): string {
    if (this.outcomeActionTypeService.types && this.outcomeActionTypeService.types.length != 0) {
      var action = this.outcomeActionTypeService.types.filter(x => x.outcomeActionTypeId == actionId);
      if (action.length != 0) {
        return action[0].type;
      }
      else {
        return "Outcome Action Title Not Found";
      }
    }
    else {
      return "Outcome Action Title Not Found";
    }

  }

  async getProjectOutcomes() {
    var projectOutcomesRelationList = await this.ProjectOutcomeRelationService.getProjectOutcomeRelationByProjectId(this.projectId);
    this.projectOutcomes = [];
    return await new Promise<void>((resolve) => {
      if (projectOutcomesRelationList.length != 0) {
        let projectOutcomeRelationsOutcomeIds = projectOutcomesRelationList.map(x => { return x.outcomeId });
        let outcomesOnly = this.outcomeService.outcomeGroups.filter(y => projectOutcomeRelationsOutcomeIds.includes(y.outcomeId));
        if (outcomesOnly.length != 0) {
          outcomesOnly.forEach(outcome => {
            this.outcomeService.getOutcomeForGroup(outcome.outcomeId).subscribe(outcomesAdded => {
              this.outcomeService.getSubOutcomesOnlyFromDb().then(x => {
                let subOutcomes = this.outcomeService.outcomes.filter(x => outcomesAdded.find(y => y.outcomeId == x.outcomeId));
                this.projectOutcomes.push(outcome);
                subOutcomes.forEach(subOutcome => {
                  subOutcome.outcomeGroupId = outcome.outcomeId;
                  this.projectOutcomes.push(this.deepCopyService.deepCopy(subOutcome));
                });
              }
              );
            });
          });
          resolve();
        }
        else {
          resolve();
        }

      }
      else {
        resolve();
      }
    }
    );
  }

  async getProjectOutcomeGroups() {
    var projectOutcomesRelationList = await this.ProjectOutcomeRelationService.getProjectOutcomeRelationByProjectId(this.projectId);
    return await new Promise<void>((resolve) => {
      if (projectOutcomesRelationList.length != 0) {
        let projectOutcomeRelationsOutcomeIds = projectOutcomesRelationList.map(x => { return x.outcomeId });
        this.projectOutcomeGroups = this.outcomeService.outcomeGroups.filter(y => projectOutcomeRelationsOutcomeIds.includes(y.outcomeId));
        resolve();
      }
      else {
        this.projectOutcomeGroups = [];
        resolve();
      }
    });
  }

  async addOutcomeAction(event) {
    this.unfocusService.unfocus(event);

    if(this.isModalOpen === true) return;
    this.isModalOpen = true;

    await this.getProjectOutcomeGroups();
    
    if (this.projectOutcomeGroups.length != 0) {

      await this.getProjectOutcomes();
      let outcomeActions = [] as OutcomeActionType[];
      outcomeActions = await this.getOutcomeActions();
      const addOutcomeActionsModal = await this.modalController.create({
        id: 'add-outcome-actions-modal',
        component: AddOutcomeActionModalPage,
        componentProps: {
          "asset": this.asset,
          "scene": this.scene,
          "projectOutcomes": this.projectOutcomes,
          "outcomeActions": outcomeActions,
          "projectId":this.projectId,
          "addedOutcomeActions" : this.outcomeActions
        }
      });

      addOutcomeActionsModal.onDidDismiss().then(result => {
        this.setOutcomeActions().then(x => {
            if(result.data){
              this.messageService.addedSuccessfully("Outcome Action");
            }
            this.isModalOpen = false;
          });
      });

      await addOutcomeActionsModal.present();
    }
    else {
      const alert = await this.alertController.create({
        header: 'No Outcomes Added To Project',
        message: "Please add Outomes to the Project before trying to add an outcome action.",
        cssClass: 'leave-alert',
        buttons: [{
          text: 'OK',
          cssClass: 'leave-button',
          handler: () => {
          }
        }]
      });
      alert.onDidDismiss().then(() => {
        this.isModalOpen = false;
      });
      await alert.present();
    }

  }

  async getOutcomeActions() {
    return new Promise<OutcomeActionType[]>((resolve) => {
      let outcomeActions = [] as OutcomeActionType[];
      if (this.scene) {
        if(this.scene.sceneIndex ==0){
          outcomeActions = this.deepCopyService.deepCopy(this.outcomeActionTypeService.types.filter(x=>x.type.includes('Left Scene')));
          resolve(outcomeActions);
        }
        else{
          outcomeActions = this.deepCopyService.deepCopy(this.outcomeActionTypeService.types.filter(x => x.type.includes('Scene')));
          resolve(outcomeActions);
        }
      }
      else {
        var assetType = this.assetTypeService.getType(this.asset.baseAsset.assetTypeId);

        outcomeActions.push(this.outcomeActionTypeService.types.filter(x => x.type.includes('Clicked'))[0]);
        if (assetType == "Video" || assetType == "Audio") {
          
          outcomeActions.push(this.outcomeActionTypeService.types.filter(x => x.type.includes('Pressed Play'))[0]);
          
          if (assetType == "Video"){
            outcomeActions.push(this.outcomeActionTypeService.types.filter(x => x.type.includes('Watched'))[0]);
          }
          
          if (assetType == "Audio"){
            outcomeActions.push(this.outcomeActionTypeService.types.filter(x => x.type.includes('Listened'))[0]);
          }
          
          resolve(outcomeActions);
        }
        else if (assetType == "QuestionSet") {
          outcomeActions.push(this.outcomeActionTypeService.types.filter(x => x.type.includes('Passed'))[0]);
          outcomeActions.push(this.outcomeActionTypeService.types.filter(x => x.type.includes('Failed'))[0]);
          resolve(outcomeActions);
        }
        else if (assetType == "Question") {
          outcomeActions.push(this.outcomeActionTypeService.types.filter(x => x.type.includes('Correct Answer'))[0]);
          outcomeActions.push(this.outcomeActionTypeService.types.filter(x => x.type.includes('Incorrect Answer'))[0]);
          resolve(outcomeActions);
        }
        else {
          resolve(outcomeActions);
        }
      }
    })
  }

  async setOutcomeActions() {
    if (this.scene) {
      await this.outcomeActionService.getOutcomeActionBySceneId(this.scene.sceneId).then(x => {
        this.scene.outcomeActions = this.deepCopyService.deepCopy(x);
        this.outcomeActions = this.scene.outcomeActions;
      });
    }
    else {
      await this.outcomeActionService.getOutcomeActionBySceneAssetRelationId(this.asset.sceneAssetRelation.sceneAssetRelationId).then(x => {
        this.asset.outcomeActions = this.deepCopyService.deepCopy(x);
        this.outcomeActions = this.asset.outcomeActions;
      })
    }
  }

  async viewOutcomeInformation(event, outcomeId) {
    this.unfocusService.unfocus(event);

    if(this.isModalOpen === true) return;
    this.isModalOpen = true;

    if (this.projectOutcomes && this.projectOutcomes.length != 0) {
      var outcome = await this.getOutcome(outcomeId);
      if (outcome.outcomeId != 0) {
        this.unfocusService.unfocus(event);
        const modal = await this.modalController.create({
          component: ViewOutcomeModalPage,
          id: 'outcome-view-modal',
          componentProps: {
            "Outcome": outcome
          }
        });

        modal.onDidDismiss().then(() => {
          this.isModalOpen = false;
        });

        return await modal.present();
      }
      else {
        //display error
      }

    }
    else {
      //display error
    }
  }

  async getOutcome(outcomeId) {
    return new Promise<Outcome>((resolve) => {
      if (this.projectOutcomes && this.projectOutcomes.length != 0) {
        var outcome = this.projectOutcomes.filter(x => x.outcomeId == outcomeId);
        resolve(outcome[0]);
      }
      else {
        resolve(new Outcome);
      }
    })

  }

  async removeOutcomeAction(event, action: OutcomeAction) {
    this.unfocusService.unfocus(event);
    const alert = await this.alertController.create({
      header: 'Remove Outcome From Project',
      message: "Do you want to remove this outcome action?",
      cssClass: 'leave-alert',
      buttons: [{
        text: 'No',
        cssClass: 'leave-button',
        handler: () => {
        }
      }, {
        text: 'Yes',
        cssClass: 'leave-button',
        handler: () => {
          this.messageService.presentLoadingWindow("Removing Outcome Action...");
          this.outcomeActionService.removeOutcomeAction(action.outcomeActionId).then( x => {
            this.messageService.loadingWindow.dismiss();
           this.setOutcomeActions().then(x=>{
             this.messageService.removedSuccessfully("Outcome Action");
           })
          })
        }
      }]
    });
    await alert.present();
  }

  async viewHelp(event) {
    this.unfocusService.unfocus(event);

    if(this.isModalOpen === true) return;
    this.isModalOpen = true;

    const modal = await this.modalController.create({
      component: HelpModalPage,
      id: 'help-modal-OutcomesOnProject',
      componentProps: {
        "helpToDisplay": "OutcomesActivities"
      }
    });

    modal.onDidDismiss().then(() => {
      this.isModalOpen = false;
    });

    return await modal.present();
  }
}
